package org.multiplatform.kotfolio.pages.compose

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul

@Page("/compose/multi_module")
@Composable
fun MultiModuleComposePage() {
    BlogLayout(
        PageProperties(
            "Multi Module",
            ""
        ),
        BlogProperties("Jetpack Compose", "Multi Module Structure")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Multimodular communicate",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Modules rarely exist in total separation and often rely on other modules and communicate with them.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It’s important to keep the coupling low even when modules work together and exchange information frequently.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sometimes direct communication between two modules is either not desirable as in the case of architecture constraints. It may also be impossible, such as with cyclic dependencies.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                WebImage(
                    src = Resources.Images.MULTI_MODULE_CODING_1_URL,
                    modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                    contentDescription = "Multi module"
                )

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "To overcome this problem you can have a third module mediating between two other modules.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The mediator module can listen for messages from both of the modules and forward them as needed. In the image above, the checkout feature needs to know which book to purchase even though the event originated in a separate screen that is part of a different feature.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In this case, the mediator is the module that owns the navigation graph (usually an app module).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the example, we use navigation to pass the data from the home feature to the checkout feature using the Navigation component.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                    navController.navigate("checkout/bookId")
                    """.trimIndent()
                )
            }
        }
    }
}

//https://medium.com/@zabiirana27/how-gradle-decides-what-to-recompile-the-multi-module-secret-that-surprises-most-android-devs-353a5437488b